import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getProductosGenericos,
  insertProductosGenericos,
  updateProductosGenericos,
  deleteProductosGenericos,
  getProductosGenericosById,
} from 'services/catalogo'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_PRODUCTOS_GENERICOS(action) {
  try {
    const productoGenerico = yield call(getProductosGenericos, action.payload)
    if (productoGenerico.ok) {
      yield put({
        type: actions.PRODUCTO_GENERICO_LOAD_SUCCEEDED,
        payload: productoGenerico.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar los Productos Genericos')
      put({
        type: actions.PRODUCTO_GENERICO_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.PRODUCTO_GENERICO_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_PRODUCTO_GENERICO(action) {
  try {
    const productoGenerico = yield call(getProductosGenericosById, action.id)
    if (productoGenerico.ok) {
      yield put({
        type: actions.PRODUCTO_GENERICO_LOAD_SUCCEEDED,
        payload: productoGenerico.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar los Productos Genericos')
      put({
        type: actions.PRODUCTO_GENERICO_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.PRODUCTO_GENERICO_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_PRODUCTO_GENERICO(action) {
  try {
    const productoGenerico = yield call(insertProductosGenericos, action.payload)
    if (productoGenerico.ok) {
      putMessage(messageType.SUCCESS, 'Producto Generico creado correctamente')
      yield put({
        type: actions.PRODUCTO_GENERICO_INSERT_SUCCEEDED,
        payload: productoGenerico.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Producto Generico')
      yield put({
        type: actions.PRODUCTO_GENERICO_INSERT_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Producto Generico')
    yield all([
      put({
        type: actions.PRODUCTO_GENERICO_INSERT_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_PRODUCTO_GENERICO(action) {
  try {
    const productoGenerico = yield call(updateProductosGenericos, action.payload)
    if (productoGenerico.ok) {
      putMessage(messageType.SUCCESS, 'Producto Generico modificado correctamente')
      yield put({
        type: actions.PRODUCTO_GENERICO_UPDATE_SUCCEEDED,
        payload: productoGenerico.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Producto Generico')
      yield put({
        type: actions.PRODUCTO_GENERICO_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Producto Generico')
    yield all([
      put({
        type: actions.PRODUCTO_GENERICO_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_PRODUCTO_GENERICO(action) {
  try {
    const productoGenerico = yield call(deleteProductosGenericos, action.id)
    if (productoGenerico.ok) {
      putMessage(messageType.SUCCESS, 'Producto Generico eliminado correctamente')
      yield put({
        type: actions.PRODUCTO_GENERICO_DELETE_SUCCEEDED,
        id: action.id,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar Producto Generico')
      yield put({
        type: actions.PRODUCTO_GENERICO_DELETE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar Producto Generico')
    yield all([
      put({
        type: actions.PRODUCTO_GENERICO_DELETE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.PRODUCTO_GENERICO_LOAD_REQUESTED, GET_PRODUCTOS_GENERICOS),
    takeEvery(actions.PRODUCTO_GENERICO_INSERT_REQUESTED, INSERT_PRODUCTO_GENERICO),
    takeEvery(actions.PRODUCTO_GENERICO_UPDATE_REQUESTED, UPDATE_PRODUCTO_GENERICO),
    takeEvery(actions.PRODUCTO_GENERICO_DELETE_REQUESTED, DELETE_PRODUCTO_GENERICO),
  ])
}
